module.exports = __webpack_public_path__ + "img/huevo.747306cb.svg";